import SignupModule from "@/components/signup/bxp-ui-signup/src";
import { LoomOverlayTemplate } from "@/components/signup/layouts";
import { useCohort } from "@/components/user-context";
import { experiments, useExperiment } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { SignupDefault } from "../../../components/signup-default";
import { LoggedInLoomExistingSitesUser } from "../existing-sites-user";
import { LoggedInLoomNewUser } from "../new-user";

export const LoggedInLoom = ({
    shouldForceOverlayView
}: {
    shouldForceOverlayView?: boolean;
} = {}) => {
    const cohort = useCohort();
    const experimentResult = useExperiment(experiments.gwp7282loomlofisignup);

    // Default cohorts not part of loom lofi experiment
    if (cohort === undefined) {
        return null;
    } else if (
        cohort === "managed-user" ||
        cohort === "week-one-user" ||
        cohort === "upgrade-eligible-user"
    ) {
        return <SignupDefault />;
    }

    if (!shouldForceOverlayView) {
        // Fire exposure unless we are forcing overlay
        experimentResult.type === "enrolled" && experimentResult.fireExposure();
    }

    const shouldShowOverlay =
        shouldForceOverlayView ||
        (experimentResult.type === "enrolled" && experimentResult.value);

    if (!shouldShowOverlay) {
        return <SignupDefault />;
    }
    if (cohort === "new-user") {
        return <LoggedInLoomNewUser />;
    }
    if (
        cohort === "existing-user" ||
        cohort === "current-product-user" ||
        checkFeatureFlagGate(featureFlags.signupModuleDeprecation)
    ) {
        return <LoggedInLoomExistingSitesUser />;
    }

    return (
        <LoomOverlayTemplate size="sm">
            <SignupModule isNewUser={false} bundle="loom" edition="free" />
        </LoomOverlayTemplate>
    );
};
